import React from 'react';
import { Box } from '@mui/material';
import LoginForm from '../components/auth/LoginForm';

const Login: React.FC = () => {
  return (
    <Box>
      <LoginForm />
    </Box>
  );
};

export default Login;
